import { render, staticRenderFns } from "./adminSystem.vue?vue&type=template&id=2717fd4c&scoped=true&"
import script from "./adminSystem.vue?vue&type=script&lang=js&"
export * from "./adminSystem.vue?vue&type=script&lang=js&"
import style0 from "./adminSystem.vue?vue&type=style&index=0&id=2717fd4c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2717fd4c",
  null
  
)

export default component.exports